import { connectRouter, RouterState } from 'connected-react-router'
import { Action, combineReducers } from 'redux'
import { clearState } from '../../common/auth/authActions'
import { auth, AuthState } from '../../common/auth/authReducer'
import notifications, { NotificationState } from '../../common/notifications/NotificationReducers'
import { activity, ActivityState } from '../../views/Activity/store/ActivityReducer'
//import { benefits, BenefitsState } from '../../views/Benefits/store/BenefitsReducer'
/*import {
  benefitsManagement,
  BenefitsManagementState,
} from '../../views/BenefitsManagement/store/BenefitsManagementReducer'*/
import { settings, SettingsState } from '../../views/Settings/store/SettingsReducer'
import { statistics, StatisticsState } from '../../views/Statistics/store/StatisticsReducer'
import { progress, ProgressState } from '../../views/Progress/store/ProgressReducer'
import { userManagement, UserManagementState } from '../../views/UserManagement/store/UserManagementReducer'
import { integration, IntegrationState } from '../../common/integration/integrationReducer'
import { History } from 'history'
import { companyRanking, CompanyRankingState } from '../../views/CompanyRanking/store/CompanyRankingReducer'
import { dashboard, DashboardState } from '../../views/Dashboard/store/DashboardReducer'
import { loading, LoadingState } from '../../common/loading/loadingReducer'
//import { chat, ChatState } from '../../views/ChallengeChat/store/ChatReducer'

export interface IGlobalState {
  router: RouterState
  auth: AuthState
  activity: ActivityState
  userManagement: UserManagementState
  settings: SettingsState
  //benefitsManagement: BenefitsManagementState
  notifications: NotificationState
  statistics: StatisticsState
  dashboard: DashboardState
  progress: ProgressState
  //benefits: BenefitsState
  integration: IntegrationState
  companyRanking: CompanyRankingState
  loading: LoadingState
  //chat: ChatState
}

const combinedReducers = (history: History) =>
  combineReducers({
    auth,
    userManagement,
    activity,
    //benefitsManagement,
    settings,
    router: connectRouter(history),
    notifications,
    statistics,
    dashboard,
    progress,
    //benefits,
    integration,
    companyRanking,
    loading,
    //chat,
  })

export const appReducer = (history: any) => (state: IGlobalState, action: Action) => {
  // This empties the entire state on logout.
  if (action.type === String(clearState)) {
    return combinedReducers(history)(undefined, action)
  }

  return combinedReducers(history)(state, action)
}
